(function () {
  function initializeUrbanHeader(section) {
    if (!section || section.dataset.ulReady === "true") return;

    section.dataset.ulReady = "true";

    var sectionId = section.dataset.sectionId;
    var drawer = document.getElementById("ul-mobile-drawer-" + sectionId);
    var overlay = document.getElementById("ul-mobile-overlay-" + sectionId);
    var searchPanel = document.getElementById("ul-search-panel-" + sectionId);

    var menuOpen = section.querySelector("[data-ul-menu-open]");
    var menuClose = drawer
      ? drawer.querySelector("[data-ul-menu-close]")
      : null;

    var searchOpen = section.querySelector("[data-ul-search-open]");
    var searchClose = searchPanel
      ? searchPanel.querySelectorAll("[data-ul-search-close]")
      : [];

    var searchInput = searchPanel
      ? searchPanel.querySelector("[data-ul-search-input]")
      : null;

    function lockScroll() {
      document.documentElement.classList.add("ul-lock-scroll");
      document.body.classList.add("ul-lock-scroll");
    }

    function unlockScroll() {
      document.documentElement.classList.remove("ul-lock-scroll");
      document.body.classList.remove("ul-lock-scroll");
    }

    function openDrawer() {
      closeSearch();

      if (!drawer) return;

      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");

      if (overlay) overlay.hidden = false;

      if (menuOpen) {
        menuOpen.setAttribute("aria-expanded", "true");
      }

      lockScroll();
    }

    function closeDrawer() {
      if (!drawer) return;

      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");

      if (overlay) overlay.hidden = true;

      if (menuOpen) {
        menuOpen.setAttribute("aria-expanded", "false");
      }

      unlockScroll();
    }

    function openSearch() {
      closeDrawer();

      if (!searchPanel) return;

      searchPanel.classList.add("is-open");
      searchPanel.setAttribute("aria-hidden", "false");

      if (searchOpen) {
        searchOpen.setAttribute("aria-expanded", "true");
      }

      lockScroll();

      window.setTimeout(function () {
        if (searchInput) searchInput.focus();
      }, 150);
    }

    function closeSearch() {
      if (!searchPanel) return;

      searchPanel.classList.remove("is-open");
      searchPanel.setAttribute("aria-hidden", "true");

      if (searchOpen) {
        searchOpen.setAttribute("aria-expanded", "false");
      }

      unlockScroll();
    }

    if (menuOpen) menuOpen.addEventListener("click", openDrawer);
    if (menuClose) menuClose.addEventListener("click", closeDrawer);
    if (overlay) overlay.addEventListener("click", closeDrawer);
    if (searchOpen) searchOpen.addEventListener("click", openSearch);

    searchClose.forEach(function (button) {
      button.addEventListener("click", closeSearch);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeDrawer();
        closeSearch();
      }
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth > 990) closeDrawer();
    });
  }

  function initializeAllHeaders() {
    document.querySelectorAll("[data-ul-header]").forEach(function (header) {
      initializeUrbanHeader(header);
    });
  }

  document.addEventListener("DOMContentLoaded", initializeAllHeaders);
  document.addEventListener("shopify:section:load", initializeAllHeaders);

  /* Wishlist local-storage helper */
  window.UrbanLibazWishlist = {
    get: function () {
      try {
        return JSON.parse(localStorage.getItem("urbanLibazWishlist")) || [];
      } catch (error) {
        return [];
      }
    },

    add: function (productHandle) {
      var list = this.get();

      if (list.indexOf(productHandle) === -1) {
        list.push(productHandle);
        localStorage.setItem("urbanLibazWishlist", JSON.stringify(list));
      }

      this.updateCount();
    },

    remove: function (productHandle) {
      var list = this.get().filter(function (handle) {
        return handle !== productHandle;
      });

      localStorage.setItem("urbanLibazWishlist", JSON.stringify(list));
      this.updateCount();
    },

    toggle: function (productHandle) {
      var list = this.get();

      if (list.indexOf(productHandle) === -1) {
        this.add(productHandle);
        return true;
      }

      this.remove(productHandle);
      return false;
    },

    updateCount: function () {
      var count = this.get().length;

      document.querySelectorAll("[data-ul-wishlist-count]").forEach(function (el) {
        el.textContent = count;
      });
    }
  };

  document.addEventListener("DOMContentLoaded", function () {
    window.UrbanLibazWishlist.updateCount();
  });
})();